import { Server } from "miragejs";

export function routes(server: Server, token: string) {
  server.get("/time", () => new Date());

  server.get("/products", () => {
    return {
      data: [
        {
          id_produto: 1,
          id_subproduto: 1,
          cd_produto: "AN    ",
          nm_produto: "AUTOMOVEIS",
          id_categoria_produto: 2,
          cd_subproduto: "000001",
          nm_subproduto: "AUTOMOVEIS",
        },
        {
          id_produto: 2,
          id_subproduto: 2,
          cd_produto: "MT    ",
          nm_produto: "MOTOCICLETAS",
          id_categoria_produto: 5,
          cd_subproduto: "000002",
          nm_subproduto: "MOTOCICLETAS",
        },
        {
          id_produto: 3,
          id_subproduto: 3,
          cd_produto: "IM    ",
          nm_produto: "IMOVEIS",
          id_categoria_produto: 14,
          cd_subproduto: "000003",
          nm_subproduto: "IMOVEIS",
        },
        {
          id_produto: 4,
          id_subproduto: 4,
          cd_produto: "TR    ",
          nm_produto: "CAMINHÃO, TRATOR E EQUIP",
          id_categoria_produto: 3,
          cd_subproduto: "000004",
          nm_subproduto: "CAMINHÕES, TRATORES ",
        },
        {
          id_produto: 5,
          id_subproduto: 5,
          cd_produto: "SE    ",
          nm_produto: "SERVIÇOS",
          id_categoria_produto: 13,
          cd_subproduto: "000005",
          nm_subproduto: "SERVIÇOS",
        },
        {
          id_produto: 6,
          id_subproduto: 6,
          cd_produto: "OB    ",
          nm_produto: "MOVEIS PLANEJADOS",
          id_categoria_produto: 12,
          cd_subproduto: "000006",
          nm_subproduto: "MOVEIS PLANEJADOS",
        },
      ],
      notifications: [],
    };
  });

  server.passthrough();
}
